<template>
  <main class="relative p-5 flex flex-col justify-center items-center">
    <section class="flex flex-col text-center rounded-md mb-10 w-full md:max-w-5xl md:mt-24">
      <div class="bg-green p-10">
        <h1 class="text-5xl font-bold mb-5">{{ this.$translations[this.$root.language].currency }}{{ this.$root.savingsCostGlobal.toLocaleString() }} </h1>
        <p class="text 2xl font-bold">{{ this.$translations[this.$root.language].savingsOfProduct}}: {{ this.$root.savingsAmountGlobal }}
          <span v-if="this.$root.implementGlobal === 'sprayer'">Litres</span>
          <span v-else>Kg</span>
        </p>
        <p class="text 2xl font-bold">{{ this.$translations[this.$root.language].newApplicationCost }}: {{ this.$translations[this.$root.language].currency }}{{ this.$root.newApplicationCostGlobal.toLocaleString() }}</p>
        <p class="text 2xl font-bold mb-5">{{this.$translations[this.$root.language].savingsPercentage}}: {{ this.$root.savingsPercentageGlobal }}%</p>
        <h2 class="text-3xl font-bold mb-10">{{ this.$translations[this.$root.language].yourSavings }}</h2>
        <p class="font-bold">{{ this.$translations[this.$root.language].findPrecisionFarming }}</p>
      </div>
    </section>
    <section class="flex flex-col justify-center max-w-5xl mb-10 md:flex-row">
      <div class="advert flex flex-col items-center justify-center rounded-md w-full p-5 h-56 mb-5 relative md:mr-5"
      :style="{ 'background': 'center/cover no-repeat url(' + this.$root.publicPath + this.$adverts[this.$root.implementGlobal][this.$root.language][this.$root.fieldSizeGlobal].product.image + ')' }">
        <div class="darken-layer rounded-md absolute w-full h-full"></div>
        <h3 class="z-20 text-2xl text-center font-bold">{{ this.$adverts[this.$root.implementGlobal][this.$root.language][this.$root.fieldSizeGlobal].product.title }}</h3>
        <p class="z-20 text-center mb-2">{{ this.$adverts[this.$root.implementGlobal][this.$root.language][this.$root.fieldSizeGlobal].product.description }}</p>
        <a class="z-20 back-button hover-green-bg" :href="this.$adverts[this.$root.implementGlobal][this.$root.language][this.$root.fieldSizeGlobal].product.link" target="_BLANK">Read More</a>
      </div>
      <div class="advert flex flex-col items-center justify-center rounded-md w-full p-5 h-56 mb-20 relative"
      :style="{ 'background': 'center/cover no-repeat url(' + this.$root.publicPath + this.$adverts[this.$root.implementGlobal][this.$root.language].isoMatch.image + ')' }">
        <div class="darken-layer rounded-md absolute w-full h-full"></div>
        <h3 class="z-20 text-2xl font-bold">{{ this.$adverts[this.$root.implementGlobal][this.$root.language].isoMatch.title }}</h3>
        <p class="z-20 text-center mb-2">{{ this.$adverts[this.$root.implementGlobal][this.$root.language].isoMatch.description }}</p>
        <a class="z-20 back-button hover-green-bg" :href="this.$adverts[this.$root.implementGlobal][this.$root.language].isoMatch.link" target="_BLANK">Read More</a>
      </div>
    </section>
    <div class="back-button-wrapper px-5 mb-4 w-auto 3xl:px-5">
      <router-link class="hover-green-bg back-button rounded-sm self-start" to="/calculator">{{ this.$translations[this.$root.language].back }}</router-link>
    </div>
  </main>
</template>

<style lang="scss" scoped>
  @media(min-width: 2560px) { //4xl
    main {
      min-height: 83vh;
    }
  }
    @media(min-width: 3840px) { // 5xl
    main {
      min-height: 89vh;
    }
  }
</style>

<script>
export default {
  beforeCreate: function () {
    const keysArray = ['savingsPercentageGlobal', 'savingsCostGlobal', 'savingsAmountGlobal', 'newApplicationCostGlobal', 'implementGlobal',
    'fieldSizeGlobal']
    // If any of our variables don't exist, redirect user back to the home page.
    keysArray.forEach(key => {
      if (sessionStorage.getItem(key)) {
        this.$root[key] = sessionStorage.getItem(key)
      } else {
        this.$router.push('/')
      }
    })
  }
}
</script>